import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ContactForm from "../../components/ContactForm";
import CTAButton from "../../components/CTAButton";
import SEO from "../../components/SEO";

const TrainingCertifying = () => {
  return (
    <>
      <SEO 
        title="Cleaner Training & Certification in Kampala | Professional Cleaning Courses"
        description="Professional cleaner training & certification programs in Kampala. Comprehensive courses in cleaning techniques, safety & eco-friendly methods. Job placement assistance. Call 0752 058 190"
        keywords="cleaner training Kampala, cleaning certification Uganda, professional cleaning courses, cleaner certification program, cleaning skills training Uganda"
        url="https://blossomcleaningservices.com/services/training-certifying"
      />
      <Header />

      <Box
        sx={{
          position: "relative",
          py: 12,
          backgroundImage: "url(/images/clean5.JPG)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: 400, md: 700 },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(34, 51, 95, 0.75)",
          },
        }}
      >
        <Container sx={{ position: "relative", zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              sx={{
                mb: 3,
                color: "white",
                fontSize: { xs: "2.5rem", md: "3.5rem" },
              }}
            >
              Training & Certifying Cleaners
            </Typography>
            <Typography
              variant="h5"
              sx={{ maxWidth: 800, color: "rgba(255,255,255,0.95)", mb: 4 }}
            >
              Professional cleaning training programmes with industry-recognised
              certification
            </Typography>
            <CTAButton to="/contact">Enroll Now</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            Become a Certified Professional Cleaner
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Our comprehensive training programme equips you with the skills,
            knowledge, and certification needed to excel in the professional
            cleaning industry. Whether you're starting a career or upgrading
            your skills, our courses provide practical, hands-on training.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Course topics include cleaning techniques, safety protocols,
            eco-friendly products, customer service, and business management.
            Upon completion, receive an industry-recognised certificate that
            opens doors to employment opportunities.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            We are credited by DIT under ministry of Education and sports and u
            can put that certificate I sent to you on that very service
          </Typography>
        </Container>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <img
          src="/images/cert.JPG"
          alt="Certification"
          style={{ width: 600, height: "auto", borderRadius: 8 }}
        />
      </Box>
      <Box sx={{ py: 8, backgroundColor: "background.paper" }}>
        <Container maxWidth="md">
          <ContactForm title="Apply for Training" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default TrainingCertifying;
